import { useMemo } from 'react';
import { useGoals } from '@atlassian/global-shortcuts/goals';
import type { ShortcutsConfig } from '@atlassian/global-side-navigation/types';
import { GLOBAL_APP_MENU_ID } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';

export function useShortcuts(): ShortcutsConfig {
	const goals = useGoals(() => 'https://home.atlassian.com/goals', {
		menuItemId: GLOBAL_APP_MENU_ID.GLOBAL_APP_GOALS,
	});

	return useMemo(
		() => ({
			[GLOBAL_APP_MENU_ID.GLOBAL_APP_GOALS]: goals,
		}),
		[goals],
	);
}
